import React from 'react'
import LogEvent from './LogEvent'
import { formatAuditDateTime } from 'helpers/datetime'
import Link from './event-link'
import { actionText, toFromText } from './text-helper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTable } from '@fortawesome/free-solid-svg-icons'
import MutedText from 'shared/forms/muted-text'

function DataAccessEvent({ log }) {
  return (
    <LogEvent
      title={
        <>
          <FontAwesomeIcon icon={faTable} className="me-2" /> Data Access{' '}
          {actionText(log.action)}{' '}
        </>
      }
      timestamp={`${formatAuditDateTime(log.changed_at)} by ${
        log.changed_by.external_id
      }`}
    >
      <MutedText as="div">
        {actionText(log.action)}{' '}
        <Link linkObject={log.linkable} objectType="data-access" />{' '}
        {toFromText(log.action)}{' '}
        <Link linkObject={log.changeable} objectType="roles" />
        <br />
        New Value: {log.new_value}
      </MutedText>
    </LogEvent>
  )
}

export default DataAccessEvent
